import React, { Component } from 'react';

import socialHttp from '../../../../utils/socialHttp';

import ReduxConnect from 'Demora/redux-connect';

import AsyncSelect from 'react-select/async';

import confirm from 'Demora/modals/confirm';

import Promise from 'promise';

const styles = {
	multiValue: (base, state) => {
		return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
	},
	multiValueLabel: (base, state) => {
		return state.data.isFixed
			? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 }
			: base;
	},
	multiValueRemove: (base, state) => {
		return state.data.isFixed ? { ...base, display: 'none' } : base;
	},
};

const orderOptions = (values) => {
	return values
		.filter((v) => v.isFixed)
		.concat(values.filter((v) => !v.isFixed));
};

class GroupEditAdmins extends Component {
	constructor(props) {
		super();

		let obj = props.obj;

		let feed = props.feed[obj];

		this.state = {
			obj: obj,
			feed: feed,
			creator: feed.creator,
			admins: [],
			options: [],
			fetching: false,
			search: '',
			fetched: [],
			resolve: null,
		};
	}

	componentDidMount() {
		let a = this.getAdmins();

		this.setState({
			admins: a,
			options: a,
		});
	}

	getAdmins = () => {
		let state = this.state;

		let props = this.props;

		let users = props.users;

		let obj = this.state.obj;

		let admins = [];

		return orderOptions(
			props.feed[obj].admins.map((u) => {
				let uu = users[u + '-u'];

				uu.value = u;
				uu.label = uu.first_name + ' ' + uu.last_name;

				if (state.creator == u) {
					uu.isFixed = true;
				}

				return uu;
			})
		);
	};

	filterOptions = (search) => {
		if (!search) {
			search = this.state.search;
		}

		let myRe = new RegExp(search, 'i');

		let g = this.state.fetched.filter((f) => myRe.exec(f.label));

		return g;
	};

	getOptions = (inputValue) => {
		this.setState({
			search: inputValue,
		});

		if (inputValue.length < 3) {
			return;
		}

		if (inputValue.length > 3) {
			return new Promise((resolve) => {
				if (this.state.fetching) {
					this.setState({
						resolve,
					});
				} else {
					resolve(this.filterOptions(inputValue));
				}
			});
		}

		this.setState({
			fetching: true,
		});

		return socialHttp(
			'get',
			'/data/feed/' + this.props.obj + '/searchFollowers?search=' + inputValue
		)
			.then((d) => {
				if (!d.users) {
					return [];
				}

				let a = Object.keys(d.users).map((u) => {
					let uu = d.users[u];

					u = u.split('-')[0];

					uu.value = u;
					uu.label = uu.first_name + ' ' + uu.last_name;

					if (this.state.creator == u) {
						uu.isFixed = true;
					}

					return uu;
				});

				this.setState({
					fetching: false,
					fetched: a,
				});

				if (this.state.resolve) {
					setTimeout(() => {
						this.state.resolve(this.filterOptions());

						this.setState({
							resolve: null,
						});
					}, 1);
				}

				return a;
			})
			.catch((e) => {
				throw e;
			});
	};

	changeAdmins = (value, opts) => {
		let action = opts.action;
		let removedValue = opts.removedValue;
		let option = opts.option;

		switch (action) {
			case 'remove-value':
			case 'pop-value':
				if (removedValue.isFixed) {
					return;
				}
				break;
			case 'clear':
				value = this.state.admins.filter((v) => v.isFixed);
				break;
		}

		let add = action == 'select-option';

		confirm({
			id: 'changegroupadmin',
			header: 'Group Admins',
			message:
				'Are you sure you want to ' +
				(add ? 'add' : 'remove') +
				' ' +
				(add ? option.label : removedValue.label) +
				' as an admin?',
			confirmFunc: () => {
				this.confirmChange(
					add ? 'post' : 'delete',
					value,
					add ? option : removedValue
				);
			},
			confirmButtonText: 'Confirm',
		});
	};

	confirmChange = (method, value, user) => {
		socialHttp(method, '/data/groups/' + this.props.obj + '/admin', {
			uid: user.value,
		})
			.then((data) => {
				value = orderOptions(value);

				this.setState({
					admins: value,
				});
			})
			.catch((e) => {
				throw e;
			});
	};

	render() {
		let state = this.state;

		if (this.props.user.id != state.creator) {
			return null;
		}

		return (
			<div>
				<AsyncSelect
					defaultOptions={state.options}
					loadOptions={this.getOptions}
					onChange={this.changeAdmins}
					value={state.admins}
					styles={styles}
					isClearable={false}
					isMulti
					placeholder='Group Admins'
					noOptionsMessage={() => 'Type in the box above to add an admin'}
					clearable={false}
				/>
			</div>
		);
	}
}

export default ReduxConnect(GroupEditAdmins, {
	feed: 'feed',
	user: 'user',
	users: 'users',
});
